module.exports = __webpack_public_path__ + "static/media/YouTube.209d9a22.svg";